module.exports = "/_next/static/images/InternalSecurity@2x-8c7119db5c767bef74855998fb63f513.webp";